export default __webpack_public_path__ + "static/media/YEL.58388a2b.svg";